import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Heading, Paragraph } from '@digdir/designsystemet-react';
import type { AreaLeft } from '../../../api/workEnvironmentTypes';
import { areaLeftText, byRiskAndDeadline } from '../areasLeftView';
import classes from '../WorkEnvironmentSurveyRisk.module.css';

const K = 'workEnvironmentAreasLeft';

type Props = {
  areas: AreaLeft[];
  /** Opens the area, to make a plan or register a decision for it */
  onChoose: (areaKey: string) => void;
};

/**
 * Once a plan is approved, the team leader hears which areas still lack a plan or a decision. The
 * approval never waits for them, but the requirements in the inspection report do.
 */
export const AreasLeftNotice = ({ areas, onChoose }: Props): ReactElement | null => {
  const { t, i18n } = useTranslation();
  if (areas.length === 0) return null;
  return (
    <Alert data-color="warning" data-size="sm">
      <Heading level={2} data-size="2xs">
        {t(`${K}.stillTitle`)}
      </Heading>
      <ul className={classes.areasLeft}>
        {byRiskAndDeadline(areas).map((area) => (
          <li key={area.key}>
            <Paragraph data-size="sm">{areaLeftText(area, t, i18n.language, 'still')}</Paragraph>
            <Button variant="tertiary" data-size="sm" onClick={() => onChoose(area.key)}>
              {t(`${K}.planFor`, { name: area.name })}
            </Button>
          </li>
        ))}
      </ul>
    </Alert>
  );
};
